import React from 'react'

import HeaderWidget from '../../../../../components/atoms/HeaderWidget'
import Loading from '../Loading'

import { useStats } from '../../../../../providers/StatsProvider'

const OpenConvos: React.FC = () => {
  const { chatStats, chatLoaded } = useStats()

  return (
    <HeaderWidget title='Number of Open Conversations'>
      {chatLoaded ? chatStats.open : <Loading />}
    </HeaderWidget>
  )
}

export default OpenConvos
